import { CAMPAIGN_SCHEDULE, HALLOWEEN_PROMO_GIFT_COUPON, HALLOWEEN_PROMO_GIFT_SKU } from '../../constants';
import { CartCouponResponse, CartItemResponse } from '../../model';
import { isWithinDateRangeInclusiveInTimeZone } from '../date';

export const getFilteredHalloweenPromoItems = (items: CartItemResponse[]) => {
  return items.filter((item) => !HALLOWEEN_PROMO_GIFT_SKU.includes(item.sku));
};

export const filterHalloweenPromoCoupon = (coupons: CartCouponResponse[]) => {
  return coupons.filter((coupon) => coupon.code !== HALLOWEEN_PROMO_GIFT_COUPON);
};
